import { useSelector } from 'react-redux';
import { BuildersLink } from '../../components/BuildersLink';
import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectSubdomain } from '../../selectors/locations/selectSubdomain';

export const BuildersLinkContainer = () => {
  const { custom } = useApplicationContext();
  const subdomain = useSelector(selectSubdomain(custom.subdomain));

  return (
    <BuildersLink
      link={`https://${subdomain}.cian.ru/country-builders/?utm_medium=country-builders-projects&utm_content=link`}
    />
  );
};
